"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Orbus Artwork Uploader
 * Artwork uploader, PDF preflight queue & processor.  Please refer to the [AWS Developer Guide](https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingRESTAPImpUpload.html) for multipart uploads.  The upload-related methods do not take file data themselves, rather they act as helper methods for using the AWS S3 APIs.  It is strongly recommended that you use Uppy and its [AWS S3 Multipart plugin](https://uppy.io/docs/aws-s3-multipart/) to assist with uploading files. The provided demo/example code offers a functioning example.
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteUploadDTOToJSON = exports.CompleteUploadDTOFromJSONTyped = exports.CompleteUploadDTOFromJSON = void 0;
const runtime_1 = require("../runtime");
function CompleteUploadDTOFromJSON(json) {
    return CompleteUploadDTOFromJSONTyped(json, false);
}
exports.CompleteUploadDTOFromJSON = CompleteUploadDTOFromJSON;
function CompleteUploadDTOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'variables': !runtime_1.exists(json, 'variables') ? undefined : json['variables'],
        'key': json['key'],
        'uploadId': json['uploadId'],
        'parts': json['parts'],
        'profile': !runtime_1.exists(json, 'profile') ? undefined : json['profile'],
        'quickCheckProfile': !runtime_1.exists(json, 'quickCheckProfile') ? undefined : json['quickCheckProfile'],
        'startThumbnails': !runtime_1.exists(json, 'startThumbnails') ? undefined : json['startThumbnails'],
        'endThumbnails': !runtime_1.exists(json, 'endThumbnails') ? undefined : json['endThumbnails'],
        'analyzeOnly': json['analyzeOnly'],
        'type': json['type'],
        'originalFilename': json['originalFilename'],
        'pdfReport': !runtime_1.exists(json, 'pdfReport') ? undefined : json['pdfReport'],
        'deleteInput': !runtime_1.exists(json, 'deleteInput') ? undefined : json['deleteInput'],
    };
}
exports.CompleteUploadDTOFromJSONTyped = CompleteUploadDTOFromJSONTyped;
function CompleteUploadDTOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'variables': value.variables,
        'key': value.key,
        'uploadId': value.uploadId,
        'parts': value.parts,
        'profile': value.profile,
        'quickCheckProfile': value.quickCheckProfile,
        'startThumbnails': value.startThumbnails,
        'endThumbnails': value.endThumbnails,
        'analyzeOnly': value.analyzeOnly,
        'type': value.type,
        'originalFilename': value.originalFilename,
        'pdfReport': value.pdfReport,
        'deleteInput': value.deleteInput,
    };
}
exports.CompleteUploadDTOToJSON = CompleteUploadDTOToJSON;
